import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";


const API = "https://mocktest.bbmclasses.com/api";

export default function SolutionPage() {
  const { testId } = useParams();
const navigate = useNavigate(); // ✅ add this
  const [questions, setQuestions] = useState([]);
  const [index, setIndex] = useState(0);
  const [showSolution, setShowSolution] = useState(false);
  const [lang, setLang] = useState("en");
  const [loading, setLoading] = useState(true);

  // UI
  const [slide, setSlide] = useState("slide-in");
  const [showPalette, setShowPalette] = useState(false);

  // Swipe
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(0);

  // ✍️ Draw
  const canvasRef = useRef(null);
  const [drawMode, setDrawMode] = useState(false);
  const [drawing, setDrawing] = useState(false);

  // 🔊 Text-to-Speech
  const [autoRead, setAutoRead] = useState(true);
  const [spokenPart, setSpokenPart] = useState("");

  
  useEffect(() => {
    fetch(`${API}/get_questions.php?test_id=${testId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setQuestions(data.questions);
        setLoading(false);
      });
  }, [testId]);

  useEffect(() => {
    if (!drawMode) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    ctx.strokeStyle = "red";
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
  }, [drawMode]);

  const q = questions[index];

  const getQ = (k) =>
    q ? (lang === "hi" ? q[`${k}_hi`] : q[`${k}_en`]) : "";

  const option = (n) => getQ(`option${n}`);
/* 🔊 SPEAK SOLUTION ONLY */
const speakSolution = () => {
  if (!q) return;

  window.speechSynthesis.cancel();

  const text = getQ("solution")
    ?.replace(/<[^>]+>/g, "")
    ?.trim();

  if (!text) return;

  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = lang === "hi" ? "hi-IN" : "en-IN";
  utter.rate = 0.9;

  setSpokenPart("solution");

  utter.onend = () => setSpokenPart("");

  window.speechSynthesis.speak(utter);
};

useEffect(() => {
  if (showSolution && autoRead) {
    speakSolution();
  }
}, [showSolution]);

  /* 🔊 SPEAK FUNCTION */
  const speakQuestion = () => {
    if (!q) return;
    window.speechSynthesis.cancel();

    const parts = [
      { key: "question", text: getQ("question_text") }
    ];

    [1,2,3,4].forEach(n => {
      parts.push({ key: `option${n}`, text: option(n) });
    });

    let i = 0;

    const speakNext = () => {
      if (i >= parts.length) {
        setSpokenPart("");
        return;
      }

      const utter = new SpeechSynthesisUtterance(
        parts[i].text.replace(/<[^>]+>/g, "")
      );
      utter.lang = lang === "hi" ? "hi-IN" : "en-IN";
      utter.rate = 0.9;

      setSpokenPart(parts[i].key);

      utter.onend = () => {
        i++;
        speakNext();
      };

      window.speechSynthesis.speak(utter);
    };

    speakNext();
  };

  /* 🔊 AUTO READ */
  useEffect(() => {
    if (autoRead) speakQuestion();
  }, [index, lang]);

  const changeQuestion = (newIndex, dir) => {
    setSlide(dir === "next" ? "slide-left" : "slide-right");
    setTimeout(() => {
      setIndex(newIndex);
      setShowSolution(false);
      clearCanvas();
      setSlide("slide-in");
    }, 250);
  };

  /* SWIPE */
  const handleTouchStart = (e) => {
    if (drawMode) return;
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (drawMode) return;
    setEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (drawMode || !startX || !endX) return;
    const diff = startX - endX;
    if (diff > 50 && index < questions.length - 1)
      changeQuestion(index + 1, "next");
    if (diff < -50 && index > 0)
      changeQuestion(index - 1, "prev");
    setStartX(0);
    setEndX(0);
  };

  /* DRAW */
  const startDraw = (e) => {
    setDrawing(true);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(
      e.touches ? e.touches[0].clientX : e.clientX,
      e.touches ? e.touches[0].clientY : e.clientY
    );
  };

  const draw = (e) => {
    if (!drawing) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(
      e.touches ? e.touches[0].clientX : e.clientX,
      e.touches ? e.touches[0].clientY : e.clientY
    );
    ctx.stroke();
  };

  const stopDraw = () => setDrawing(false);

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
  };

  if (loading) return <p style={styles.center}>Loading...</p>;
  if (!q) return <p style={styles.center}>No Questions Found</p>;


  return (
    <div style={styles.container}>

      {/* HEADER */}
      <header style={styles.header}>
        <button style={styles.iconBtn} onClick={() => setShowPalette(true)}>☰</button>

        <div>
          <b> BBM Classes </b>
          <div style={{ fontSize: 12 }}>Q {index + 1}/{questions.length}</div>
        </div>
        <div>
          <button style={styles.iconBtn} onClick={() => setAutoRead(a => !a)}>
            {autoRead ? "🔊" : "🔇"}
          </button>
          <button style={styles.iconBtn} onClick={() => setDrawMode(d => !d)}>✍️</button>
          <button style={styles.langBtn} onClick={() => setLang(l => l === "en" ? "hi" : "en")}>
            {lang === "en" ? "हिन्दी" : "English"}
          </button>
        </div>
      </header>

      {/* QUESTION CARD */}
      <div
        className={slide}
        style={styles.card}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
      {/* QUESTION NUMBER */}
<div style={styles.qOnly}>
  Question: {index + 1}
</div>  
        
        <div
          style={{
            background: spokenPart === "question" ? "#fff3cd" : "transparent",
            padding: 6,
            borderRadius: 6
          }}
          dangerouslySetInnerHTML={{ __html: getQ("question_text") }}
        />

        {[1,2,3,4].map(n => {
          const isCorrect = showSolution && q.correct_option == n;
          return (
            <div key={n} style={{
              ...styles.option,
              background:
                spokenPart === `option${n}`
                  ? "#dbeafe"
                  : isCorrect
                  ? "#d4edda"
                  : "#fff"
            }}>
              <b>({String.fromCharCode(64+n)})</b>{" "}
              <span dangerouslySetInnerHTML={{ __html: option(n) }} />
              {isCorrect && " ✔"}
            </div>
          );
        })}

        {showSolution && (
          <div style={styles.solution}>
            <b>Explanation:</b>
            <div dangerouslySetInnerHTML={{ __html: getQ("solution") }} />
          </div>
        )}
      </div>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <button disabled={index === 0} onClick={() => changeQuestion(index - 1, "prev")}>◀ Prev</button>
        <button
          style={{ ...styles.solutionBtn, background: showSolution ? "#dc3545" : "#28a745" }}
          onClick={() => setShowSolution(s => !s)}
        >
          {showSolution ? "Hide" : "Solution"}
        </button>
        <button disabled={index === questions.length - 1} onClick={() => changeQuestion(index + 1, "next")}>
          Next ▶
        </button>
      </footer>

      {/* QUESTION PALETTE */}
      {showPalette && (
        <div style={styles.palette}>
          <div style={styles.paletteHeader}>
            <b>Questions</b>
            <button onClick={() => setShowPalette(false)}>✕</button>
          </div>
          <div style={styles.paletteGrid}>
            {questions.map((_, i) => (
              <button
                key={i}
                style={{
                  ...styles.paletteBtn,
                  background: i === index ? "#0d6efd" : "#eee",
                  color: i === index ? "#fff" : "#000"
                }}
                onClick={() => {
                  changeQuestion(i, i > index ? "next" : "prev");
                  setShowPalette(false);
                }}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* DRAW */}
      {drawMode && (
        <>
          <canvas
            ref={canvasRef}
            style={styles.canvas}
            onMouseDown={startDraw}
            onMouseMove={draw}
            onMouseUp={stopDraw}
            onTouchStart={startDraw}
            onTouchMove={draw}
            onTouchEnd={stopDraw}
          />
          <div style={styles.drawTools}>
            <button onClick={clearCanvas}>🧽</button>
            <button onClick={() => setDrawMode(false)}>❌</button>
          </div>
        </>
      )}

      {/* SLIDE */}
      <style>{`
        .slide-left { animation: slideLeft .25s ease; }
        .slide-right { animation: slideRight .25s ease; }
        @keyframes slideLeft {
          from { transform: translateX(100%); opacity: 0 }
          to { transform: translateX(0); opacity: 1 }
        }
        @keyframes slideRight {
          from { transform: translateX(-100%); opacity: 0 }
          to { transform: translateX(0); opacity: 1 }
        }
      `}</style>

    </div>
  );
}

/* STYLES */
const styles = {
  container:{
  maxWidth:900,
  margin:"auto",
  paddingBottom:70,
  background:"#262666",   // 👈 same as card
  minHeight:"100vh"
},
  header:{ position:"sticky", top:0, background:"#1f2937", color:"#fff", padding:"6px 10px", display:"flex", justifyContent:"space-between", alignItems:"center", zIndex:10 },
  iconBtn:{ background:"none", color:"#fff", border:"none", fontSize:18 },
  langBtn:{ background:"#0d6efd", color:"#fff", border:"none", padding:"4px 8px", borderRadius:4 },
  card:{ background:"#f9f9f9", margin:10, padding:15, borderRadius:10 },
  option:{ border:"1px solid #ccc", padding:10, marginTop:8, borderRadius:6 },
  solution:{ marginTop:12, background:"#fff3cd", padding:10, borderRadius:6 },
  footer:{ position:"fixed", bottom:0, left:0, right:0, background:"#fff", borderTop:"1px solid #ccc", display:"flex", justifyContent:"space-around", padding:8 },
  solutionBtn:{ color:"#fff", border:"none", padding:"6px 12px", borderRadius:6 },
  palette:{
  position:"fixed",
  top:0,
  left:0,
  width:"70%",
  height:"100%",
  background:"#fff",
  boxShadow:"2px 0 10px rgba(0,0,0,.2)",
  zIndex:20,
  overflowY:"auto",
  WebkitOverflowScrolling:"touch"
},
qOnly: {
  fontSize: 18,
  fontWeight: "bold",
  color: "#1f2937",
  marginBottom: 6
},
  paletteHeader:{
  padding:10,
  borderBottom:"1px solid #ddd",
  display:"flex",
  justifyContent:"space-between",
  position:"sticky",
  top:0,
  background:"#fff",
  zIndex:2
},
  paletteGrid:{ padding:10, display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:8 },
  paletteBtn:{ padding:8, borderRadius:5, border:"none" },
  canvas:{ position:"fixed", top:0, left:0, zIndex:50, touchAction:"none" },
  drawTools:{ position:"fixed", bottom:80, right:10, zIndex:60, display:"flex", gap:6 },
  center:{ textAlign:"center", marginTop:50 }
};
